module.exports = {
  primary: '#9c27b0',
  secondary: '#424242',
  accent: '#82B1FF',
};
